const isPluralOf = (plural, singular) => {
  if (plural === singular + 's') {
    return true
  }
  if (plural === singular + 'es' && /[sxz]$|[cs]h$/.test(singular)) {
    return true
  }

  return singular.endsWith('y') && !/[aeiou]y$/.test(singular) && plural === singular.slice(0, -1) + 'ies'
}

const normalizeName = (name) => name.replace(/\s+/g, '').toLowerCase()

export const fieldNameImpliesEntity = (fieldName, entityName) => {
  if (!fieldName || !entityName) {
    return false
  }

  const normalizedField = normalizeName(fieldName)
  const normalizedEntity = normalizeName(entityName)

  return normalizedField === normalizedEntity ||
    normalizedField === normalizedEntity + 'id'
}

export const fieldNameIsEntityIdReference = (fieldName, entityName) => {
  if (!fieldName || !entityName) {
    return false
  }

  return normalizeName(fieldName) === normalizeName(entityName) + 'id'
}

export const isSingularPluralMatch = (name1, name2) => {
  if (name1 === name2) {
    return true
  }

  return isPluralOf(name1, name2) || isPluralOf(name2, name1)
}

export const findEntityIdByName = (camelCaseFieldName, entityNameToIdMap) => {
  const exactMatch = entityNameToIdMap.get(camelCaseFieldName)
  if (exactMatch) {
    return exactMatch
  }
  for (const [entityName, entityId] of entityNameToIdMap.entries()) {
    if (isSingularPluralMatch(camelCaseFieldName, entityName)) {
      return entityId
    }
  }
  return undefined
}
